import {getData} from './redux_data';
import {
    GET_CONTAB_CENTRO, MODIFY_CONTAB_CENTRO, ADD_CONTAB_CENTRO, REMOVE_CONTAB_CENTRO //elementos de un centro
} from '../constants/action_types';

export function getContabCentro(centroId) {
    return getData('ContabTipoMaquinaCentro/vContabTipoMaquinaCentro/' + centroId, GET_CONTAB_CENTRO);
}

export function modifyContabCentro(contab) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_CONTAB_CENTRO, payload: contab });
    }
}

export function addContabCentro(contab) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_CONTAB_CENTRO, payload: contab });
    }
}

export function removeContabCentro(contab) {
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_CONTAB_CENTRO, payload: contab });
    }
}